import { useActivityTimeline } from '@/viewmodel/features/observability/hooks/useActivityTimeline';
import {
  activityStatusKey,
  isTimelineTerminal,
  toActivityEventView,
} from '@/viewmodel/features/observability/mappers/activityTimeline';
import type { ActivityTimelineViewState } from '@/viewmodel/features/observability/types';
import { skipToken } from '@reduxjs/toolkit/query/react';
import { useEffect, useMemo, useState } from 'react';

const POLL_MS = 3000;

export function useActivityTimelineViewModel(
  correlationId: string | undefined,
  workspaceId: string | undefined,
): ActivityTimelineViewState {
  const [pollingInterval, setPollingInterval] = useState(POLL_MS);
  const { data, isLoading, isError } = useActivityTimeline(
    correlationId && workspaceId ? { workspaceId, correlationId } : skipToken,
    { pollingInterval },
  );
  const isTerminal = isTimelineTerminal(data);

  useEffect(() => {
    setPollingInterval(isTerminal ? 0 : POLL_MS);
  }, [isTerminal]);

  const events = useMemo(() => (data?.timeline.events ?? []).map(toActivityEventView), [data]);

  return {
    visible: Boolean(correlationId && workspaceId),
    events,
    isLoading,
    isError,
    isTerminal,
    statusKey: activityStatusKey(isLoading, isError, isTerminal),
  };
}
